import { useItemById } from '../../../../services/api'

/**
 * Hook to fetch evaluation item data using React Query
 * @param itemId - The ID of the item to fetch
 * @returns Object containing evaluationData and tokenRefreshError (always false with React Query)
 */
const FetchEvalDataItem = (itemId: string) => {
    const queryResult: any = useItemById(itemId)
    const evaluationData = queryResult.data
    const error = queryResult.error
    
    // For backward compatibility, we maintain the tokenRefreshError property
    // but it's always false since React Query handles authentication internally
    const tokenRefreshError = false

    // Log errors for debugging (similar to original implementation)
    if (error) {
        console.error('Error fetching evaluation:', error)
    }

    return { evaluationData, tokenRefreshError }
}

export default FetchEvalDataItem
